<template>
    <DCard
        padding
    >
        <DRow>
            <DCol>
                <DTable
                    :items="operators"
                    :fields="fields"
                    :items-per-page="25"
                    column-filter
                    hover
                    pagination
                    :pagination-props="{align: 'center'}"
                >
                    <template #actions="{item}">
                        <td class="text-right">
                            <DDropdown
                                :id="`actions_dropdown_operator_${item.id}`"
                                :class="'more-actions-button'"
                                :caret="false"
                                icon="dots-horizontal"
                            >
                                <DDropdownItem
                                    icon="pencil"
                                    mini
                                    @click="openEditModal(item)"
                                >
                                    {{ __('settings.electronic_invoice_operators.buttons.edit') }}
                                </DDropdownItem>
                                <DDropdownItem
                                    icon="trash-can-outline"
                                    mini
                                    @click="handleDeleteButton(item)"
                                >
                                    {{ __('settings.electronic_invoice_operators.buttons.delete') }}
                                </DDropdownItem>
                            </DDropdown>
                        </td>
                    </template>
                </DTable>
            </DCol>
        </DRow>
        <DModal
            v-model:show="showDeleteModal"
            :title="__('settings.electronic_invoice_operators.modal.delete_confirm_modal.title')"
            :message="__('settings.electronic_invoice_operators.modal.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="showDeleteModal = false"
            @confirm="deleteItem"
        />
        <StoreModal
            v-if="showCreateModal"
            v-model:show="showCreateModal"
            :operator="selectedItem"
            :is-create="selectedItem === null"
            @close-modal="closeCreateModal"
        />
        <DFabs>
            <DFab
                icon="plus"
                :label="__('settings.electronic_invoice_operators.buttons.create')"
                @click="openCreateModal"
            />
        </DFabs>
    </DCard>
</template>

<script>
import App from '~@/App.vue'
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import LovLayout from '~@/Pages/Settings/Lov/LovLayout.vue'
import { __ } from '~@/Composables/translation'
import StoreModal from '~@/Components/Settings/ElectronicInvoiceOperators/StoreModal'

export default {
    layout: [App, LovLayout]
}
</script>

<script setup>
defineProps({
    operators: {
        type: Array,
        default: () => {
            return []
        }
    }
})

const fields = [
    { key: 'name', label: __('settings.electronic_invoice_operators.form.name'), sorter: true },
    { key: 'identifier', label: __('settings.electronic_invoice_operators.form.identifier'), sorter: true },
    { key: 'actions', sorter: false, filter: false, label: '', _style: { minWidth: '5%' } }
]

const showDeleteModal = ref(false)
const showCreateModal = ref(false)
const selectedItem = ref(null)

function deleteItem () {
    router.delete(route('settings.electronic-invoice-operators.destroy', { operator: selectedItem.value.id }), {
        onFinish: () => {
            selectedItem.value = null
        }
    })
}

function handleDeleteButton (item) {
    selectedItem.value = item
    showDeleteModal.value = true
}

function openEditModal (item) {
    selectedItem.value = item
    showCreateModal.value = true
}

function openCreateModal () {
    showCreateModal.value = true
}

function closeCreateModal () {
    selectedItem.value = null
    showCreateModal.value = false
}
</script>
